import { BaseNomenclature } from "./baseNomenclature.model";

export class RadiationType extends BaseNomenclature {
    constructor(){
        super();
        this.collection_name="radiation_types";
    }
}